import React from "react";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";
import "./blogs.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import NarasimhaChaturdhashi from "./SignificanceOfNarasimha/assets/Narasimha Chaturdhashi.png";
import Janmasthami from "../../../Blogs/assets/Sri_Krishna_Janmashtami.webp";
import NarasimhaChaturdhashi from "./assets/436265320_852c713bf8_c.webp";

// import NityaSeva from "./NityaSevaBlog/assets/Nitya Seva.png";
import NityaSeva from "./assets/0O4A6439.webp";

// import Ekadashi from "./EkadashiImportance/assets/Ekadashi.png";
// import Radhayatra from "./SriJagannathRathYatra/assets/Radhayatra.png";
import Ekadashi from "./assets/0bfb8607a675c43c16a216e05b7377e0.webp";
import Radhayatra from "./assets/0P9A7515.webp";

import ArrowRight from "./ArrowRight.svg";
import ArrowLeft from "./ArrowLeft.svg";

const blogsData = [
  {
    img: Janmasthami,
    title: "Sri Krishna Janmashtami",
    desc: "On August 16, 2025, the city of Vijayawada will witness an extraordinary spiritual celebration – the ...",
    link: "/sri-krishna-janmashtami",
    alt: "Glories of Narasimha Chaturdashi "
  },
  {
    img: NarasimhaChaturdhashi,
    title: "Significance of Narasimha Chaturdashi",
    desc: "Each year, the Vaishnava community around the world reverently celebrates Narasimha Chaturdashi..",
    link: "/significance-of-narasimha",
    alt: "Glories of Narasimha Chaturdashi "
  },
  {
    img: NityaSeva,
    title: "Nitya Seva",
    desc: "Have you ever wondered how beautifully everything is organized during ISKCON Vijayawada temple festivals...",
    link: "/nitya-seva-blog",
    alt: "Nityasevak Seva Importance"
  },
  {
    img: Ekadashi,
    title: "Ekadashi Importance",
    desc: "Every month, there is a special day known as Ekadashi that holds great importance for devotees of Lord Vishnu...",
    link: "/ekadashi-importance",
    alt: "Ekadashi Vrata Importance"
  },
  {
    img: Radhayatra,
    title: "Sri Jagannath Rath Yatra",
    desc: "Vijayawada, located on the banks of the Krishna River, is a major cultural and commercial hub in Andhra Pradesh...",
    link: "/sri-jagannath-rath-yatra",
    alt: "Jagannath Rath Yatra Vijayawada"
  },
];

const NextArrow = ({ onClick }) => {
  return (
    <button
      className="blogsCarousel-arrow blogsCarousel-next"
      onClick={onClick}
    >
      <img src={ArrowRight} alt="Next" />
    </button>
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <button
      className="blogsCarousel-arrow blogsCarousel-prev"
      onClick={onClick}
    >
      <img src={ArrowLeft} alt="Previous" />
    </button>
  );
};


const BlogsCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="blogsCarousel-wrapper">
      <h2 className="blogsCarousel-title">Events</h2>

      <Slider {...settings}>
        {blogsData.map((blog, index) => (
          <div key={index} className="blogsCarousel-slide">
            <div className="blogsCarousel-card">
              <div className="blogsCarousel-imgContainer">
                <img src={blog.img} alt= {blog.alt}/>
              </div>
              <h3 className="blogsCarousel-cardTitle">{blog.title}</h3>
              <p className="blogsCarousel-desc">{blog.desc}</p>
              <NavLink to={blog.link}>
                <button className="blogsCarousel-readBtn">READ MORE</button>
              </NavLink>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BlogsCarousel;
